import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const SecondTable = () => {
  const cellStyle = {
    border: "1px solid #7A7A7A",
    padding: "12px",
    verticalAlign: "top",
    fontSize: "16px",
    fontFamily: "'Roboto', sans-serif",
  };

  const rows = [
    {
      option: <code style={{ color: "green" }}>curl</code>,
      meaning: "CLI Tool",
      example: (
        <code style={{ color: "green" }}>curl 'https://example.com'</code>
      ),
      description:
        "Command-line tool used to send HTTP requests to APIs or web servers.",
    },
    {
      option: (
        <>
          <code style={{ color: "green" }}>-X</code> or{" "}
          <code style={{ color: "green" }}>--request</code>
        </>
      ),
      meaning: "HTTP Method",
      example: <code style={{ color: "green" }}>-X POST</code>,
      description:
        "Specifies the request method (GET, POST, PUT, DELETE, etc). Defaults to GET.",
    },
    {
      option: (
        <>
          <code style={{ color: "green" }}>-H</code> or{" "}
          <code style={{ color: "green" }}>--header</code>
        </>
      ),
      meaning: "HTTP Header",
      example: (
        <>
          <code style={{ color: "green" }}>
            -H 'Content-Type: application/json'
          </code>
        </>
      ),
      description:
        "Adds custom HTTP headers to the request, such as content type or authorization tokens.",
    },
    {
      option: (
        <>
          <code style={{ color: "green" }}>-d</code> or{" "}
          <code style={{ color: "green" }}>--data</code>
        </>
      ),
      meaning: "Request Body",
      example: <code style={{ color: "green" }}>{`-d '{"key":"value"}'`}</code>,
      description:
        "Sends data in the body of the request; commonly used in POST or PUT requests.",
    },
    {
      option: <code style={{ color: "green" }}>https://api.example.com</code>,
      meaning: "Base URL",
      example: <code style={{ color: "green" }}>https://api.example.com</code>,
      description:
        "The root domain for all Meta (Facebook) Graph API requests. It serves as the foundation for forming API endpoints.",
    },
  ];

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          minWidth: 650,
          border: "1px solid #7A7A7A",
          borderCollapse: "collapse",
        }}
      >
        <TableHead sx={{ backgroundColor: "#f5f6f7" }}>
          <TableRow>
            <TableCell sx={cellStyle}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                Option
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "gray",
                  fontSize: "16px",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                String
              </Typography>
            </TableCell>
            <TableCell sx={cellStyle}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                Placeholder
              </Typography>
            </TableCell>
            <TableCell sx={cellStyle}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                Example Usage
              </Typography>
            </TableCell>
            <TableCell sx={cellStyle}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                Description
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow
              key={idx}
              sx={{
                backgroundColor: idx % 2 === 1 ? "#f9f9f9" : "inherit", // alternate starting from 2nd row
              }}
            >
              <TableCell sx={cellStyle}>{row.option}</TableCell>
              <TableCell sx={cellStyle}>{row.meaning}</TableCell>
              <TableCell sx={cellStyle}>{row.example}</TableCell>
              <TableCell sx={cellStyle}>{row.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SecondTable;
